// Detects the currently active route. Nav paths may contain query strings
// (e.g. "/path?defaultFilter=true"), so we strip them before comparing.
// A single-segment nav path ("/reference-tables") matches any route under it;
// a deeper nav path ("/reference-tables/non-eu-vat-rates") must match all of
// its segments so sibling sub-items are not highlighted together.
export const isPathActive = (locationPathname: string, navPath: string): boolean => {
	if (!locationPathname || !navPath) return false;
	const navSegments = navPath.split('?')[0].split('/').filter(Boolean);
	const locationSegments = locationPathname.split('/').filter(Boolean);
	if (navSegments.length === 0) return false;
	return navSegments.every((segment, index) => locationSegments[index] === segment);
};

// Converts a human-readable name into a stable URL-safe slug, used to build
// DOM ids for nav items and groups (e.g. "Finance & VAT" -> "finance-and-vat").
export const slugifyName = (name: string): string =>
	name
		.toLowerCase()
		.replace(/&/g, 'and')
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-|-$/g, '');
